#import "../../../timeline/comments/graphql/fragments/comment-fragment.graphql"
#import "./external-meeting-for-modal-fragment.graphql"
#import "./potential-activity-entity-fragment.graphql"
#import "./log-note-for-modal-fragment.graphql"
#import "../../../core-entity/graphql/fragments/core-entity-task-fragment.graphql"

fragment ActivityModalFragment on Activity {
    id
    name
    logNote {
        ...LogNoteForModalFragment
    }
    externalMeeting {
        ...ExternalMeetingForModalFragment
    }
    summary {
        id
        status
        summary
        userRating
    }
    transcription
    transcriptionStatus
    participants {
        ...PotentialActivityEntityFragment
    }
    activityType {
        id
        name
        icon
    }
    isOverdue
    startTime
    endTime
    shouldSummarize
    generatingSummary
    generatingRecording
    externalMeetingServiceType
    createdTime
    creatorUser {
        id
        name
    }
    creatorOrigin {
        id
        name
        originType
    }
    originUrl
    comments {
        totalCount
        edges {
            node {
                ...CommentFragment
            }
        }
    }
    status
    agenda
    isAllDay
    shouldDisplayAudio
    shouldDisplayVideo
    hasBooking
    loggedBy {
        name
    }
    loggedTime
    autologged
    location {
        formattedAddress
    }
    externalMeetingUrl
    relatedLeads {
        id
        name
        avatarUrl
        initials
        htmlUrl
    }
    quillDelta
    isEditable
    isConnectedToExternalCalendar
    canViewSummaryDetails
    summaryStates {
        recordingEmptyState
        transcriptionEmptyState
        summaryEmptyState
        summaryNextAction
        isNotetakerDisabled
    }
    canUserLogActivity
    linkifiedAgenda
    canUserSeeSyncStatus
    isForceSync
    isLoggable
    shouldSyncToCalendar
    previousActivity {
        id
        name
    }
    nextActivity {
        id
        name
    }
    canScheduleFollowUp
    syncOrganizerUsername
    isPrivate
    syncMode
    tasks {
        ...CoreEntityTaskFragment
    }
}
